import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
// import Header from './components/Header';
import Footer from './components/Footer';
import 'animate.css';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import '../src/assets/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../src/assets/css/style.css'; // Main CSS file
import Services from './pages/Services';
import Mobilenavbar from './components/MobileNavbar';
import SearchResults from './pages/SearchResults';

function App() {
  const [searchTerm, setSearchTerm] = useState(""); // ✅ Add State
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Router>
   {isMobile 
  ? <Mobilenavbar 
      searchTerm={searchTerm} 
      setSearchTerm={setSearchTerm} 
    /> 
  : <Navbar 
      searchTerm={searchTerm} 
      setSearchTerm={setSearchTerm} 
    />
}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products/:id" element={<Services searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
        <Route path="/search" element={<SearchResults />} /> {/* New Search Results Page */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;